var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalPropertyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "36px",
    viewBox: "0 0 28 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.66350388e-05 0.0568753043 27.9727179 0.0568753043 27.9727179 35.3043478 2.66350388e-05 35.3043478"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal-Property",
    transform: "translate(-48.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(48.000000, 244.532051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0240092,21.0861794 L14.4889264,18.6618944 L14.4889264,12.0522031 C14.4889264,11.7545681 14.2180564,11.5261984 13.8855903,11.5261984 L11.5770741,11.5261984 C11.244608,11.5261984 10.9565217,11.7545681 10.9565217,12.0522031 L10.9565217,19.6072627 L10.9565217,19.713218 C10.9565217,19.9124414 11.0353342,20.0989776 11.1455186,20.2563675 C11.2021411,20.3475783 11.2809536,20.4315881 11.3781301,20.5039395 L15.8903342,23.588645 C16.1539351,23.7707235 16.5334591,23.7244324 16.7358464,23.4885189 L18.1364891,21.8422682 C18.339259,21.6060119 18.2887578,21.267915 18.0240092,21.0861794",
    id: "Fill-1",
    fill: "#FDFDFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.569677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-personal-property-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2971641,27.7863258 C7.62393333,27.7803205 3.03013846,23.253597 3.03408464,17.674451 C3.04018974,12.0949518 7.64188205,7.5759953 13.3172667,7.57987628 C18.9904974,7.58623357 23.5842923,12.1140162 23.5803461,17.6931623 C23.574241,23.2723083 18.9721897,27.7909118 13.2971641,27.7863258 M27.0394205,15.035804 L26.3358308,15.0350979 C25.5073179,11.0764214 22.8623949,7.77016922 19.2931128,5.99789096 L19.2931128,1.01574139 C19.2931128,0.486882261 18.8609077,0.0568753043 18.3220872,0.0568753043 L8.28731795,0.0568753043 C7.74957436,0.0568753043 7.31018974,0.486882261 7.31018974,1.01574139 L7.31018974,5.99965617 C2.97449744,8.15428052 0.00434358974,12.5705014 2.66350399e-05,17.6712736 C-0.00606666667,22.8419483 3.00393333,27.2288666 7.31018974,29.367251 L7.31018974,34.345517 C7.31018974,34.8750823 7.74957436,35.3043831 8.28731795,35.3043831 L18.3224462,35.3043831 C18.8612667,35.3043831 19.2934718,34.8750823 19.2934718,34.345517 L19.2934718,29.3693692 C22.8623949,27.6013275 25.4987026,24.3046075 26.3318821,20.3554631 L27.032241,20.3575814 C27.5484462,20.3575814 27.9673692,19.9473449 27.9688051,19.4393153 L27.9727538,15.9547762 C27.9727538,15.4481588 27.5559846,15.0368631 27.0394205,15.035804",
    id: "Fill-3",
    fill: "#FDFDFB",
    mask: "url(#mask-personal-property-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalPropertyIcon);
export default __webpack_public_path__ + "static/media/personal_property_icon.fc64cdf5.svg";
export { ForwardRef as ReactComponent };